/*
  * Enter all common env URLs here
  *
*/
export const environment = {
  production: false,
  apiUrl: '/',
  ownershipService: {
    customerDetails: 'bos/sp/ownership/getCustomerByVin',
    uioOwnershipChg: 'bos/sp/ownershipChange',
    ownershipCustomerDetails: 'bos/sp/ownershipCustomerDetails',
    ownershipChangeDongle: 'bos/sp/ownershipChangeDongle',
    //deleteGuestUser:'bos/sp/deleteGuestUser'
    deleteUser:'bos/sp/deleteUser'
  },
  deviceMapping: {
    getDongleInfo: 'bos/dongle/getDongleInfo',
    dongleDeviceUpdate: 'bos/dongle/dongleDeviceUpdate'
  },
  activationPortal: {
    createUserType: 'bos/userRegistration/createUserType',
    getUserType: 'bos/userRegistration/getUserType',
    setUserDetails: 'bos/userRegistration/setUserDetails',
    resetPassword: 'bos/userRegistration/resetUserPassword',
    //postLoginCheck: 'bos/sp/postLoginCheck',
    login: 'bos/sp/login',
    logout: 'bos/sp/logout',
    activateCustomer: 'bos/dealerOperation/customer/activateCustomer',
    sendSms: 'bos/portal/sendSms',
    getCustomerDetails: 'bos/sp/vehicle/getVehicleDetails',
    getATntDetails:'/bos/sp/atnt/getatntDetails',
    getSVTDetails: 'bos/sp/svt/verifySvtDetails',
    startStopSVT: 'bos/sp/svt/startStopSvt',
    checkSVTStatus: 'bos/sp/svt/checkStatus',
    getDashboardDetails: 'bos/sp/vehicle/getDashboardData',
    getTripDetails: 'bos/sp/vehicle/getTripDetails',
    getServiceHistoryDetails: 'bos/sp/vehicle/getServiceHistoryDetails',
    getRsaDetails: 'bos/sp/vehicle/getRsaDetails',
    getTransactionDetails: 'bos/sp/vehicle/getTransactionDetails',
    getVehicleLocationDetails: 'bos/sp/vehicle/getVehicleLocation',
    getFuelLogDetails: 'bos/sp/vehicle/getFuelLogDetails',
    getInsuranceDetails: 'bos/sp/vehicle/getInsuranceDetails'
  },
  supportPortal: {
    getHistoryData: 'bos/sp/event/getEventData',
    getLiveCount: 'bos/sp/event/getEventCount',
    getCustomerList: 'bos/sp/vehicle/getVehicleList',
    getCustomerData: 'bos/sp/vehicle/getOldVehicleData',
    getLetData : 'bos/sp/vehicle/getLetData',
    // getRecordActionDetails:'supportPortal/action/getRecordActionDetails',
    getNearByLocationsData: 'bos/sp/vehicle/getNearbyLocations',
    callmeList: 'bos/sp/callMe/getCallMeDetails',
    callmeListUpdate: 'bos/sp/callMe/updateCallMe',
    forgotPassword: 'bos/sp/userRegistration/resetUserPassword',
    getVehicleLocation: 'bos/sp/vehicle/getVehicleLocation',
    getAccessToken: 'bos/sp/svt/getAccessToken',
    getSvtLocation: 'bos/sp/svt/getSvtLocation',
    getOpenTicketsCrm: 'bos/sp/crm/getTickets',
    sendOtp: 'bos/sp/userRegistration/sendOtp',
    notifyUser: 'bos/sp/notifyUser/sendSmsInternal',
    createCallback: 'bos/sp/callback/createCallback',
    getCallbackDetails : 'bos/sp/callback/getCallbackDetails',
    updateCallback : 'bos/sp/callback/updateCallback',
    sendOtpForLogin : 'bos/sp/userLogin/sendOtpForLogin',
    verifyOtpForLogin : 'bos/sp/userLogin/verifyOtpForLogin',
  },
  cti: {
    manualDialing: 'bos/sp/cti/initiateCall'
  },
  firebase: {
    apiKey: "AIzaSyAdKQxPJVYWKnY0CrxfQuocjbLDiis5n4k",
    authDomain: "hondaconnectedcars.firebaseapp.com",
    databaseURL: "https://hondaconnectedcars.firebaseio.com",
    projectId: "hondaconnectedcars",
    storageBucket: "hondaconnectedcars.appspot.com",
    messagingSenderId: "761694918802",
    appId: "1:761694918802:web:caca9a7eaad900f59f2e4b",
    measurementId: "G-VEYR6FZ22Q"
  },
  eiInterface: {
    processTrip: "bos/api/createMissingTripsBatch"
  },
  atnt :{
    getatntDetails:"bos/sp/atnt/getatntDetails"
  }
};
